<div class="question-type__text">
  <h1 class="fs__xxl">Rating</h1>
  <p class="fs__md">
    Participants provide feedback using a star or number-based rating system. Ideal for quick evaluations of products, services, or experiences.
  </p>
  <h2 class="fs__lg">Example</h2>
  <p class="fs__md">On a scale of 1-5 where 1 is very bad and 5 is very good, please rate the service.</p>
</div>
